import * as React from 'react';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'


export default function MyMonthPicker({searchDate, setSearchDate}) {
  const handleChange = (newValue) => setSearchDate(newValue);
  const [maxDate, setMaxDate] = useState(new Date());
  useEffect(()=> {
    const d = new Date();
    d.setMonth(d.getMonth() + 5);
    setMaxDate(dayjs(d).format("YYYY-MM"));
  }, [])


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        label="Year & Month"
        value={searchDate}
        openTo="month"
        minDate="2020-01"
        maxDate={maxDate}
        inputFormat="YYYY-MM"
        views={["year", "month"]}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  );
}
